import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { environment } from '../environments/environment';
import 'hammerjs';
import {
    MatSidenavModule, MatDialogModule, MatSelectModule, MatSlideToggleModule,
    MatAutocompleteModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule,
    MatTabsModule, MatProgressSpinnerModule, MatIconModule, MatMenuModule, MatToolbarModule,
    MatCardModule, MatChipsModule, MatButtonModule, MatInputModule, MatTooltipModule,
    MatRadioModule, MatPaginatorModule, MatSliderModule
} from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TreeModule, DataTableModule, SharedModule } from 'primeng/primeng';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { BaseEndpoint } from './app.constants';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TeamsComponent } from './teams/teams.component';
import { TeamListComponent } from './teams/team-list/team-list.component';
import { TeamComponent } from './teams/team/team.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoginComponent } from './login/login.component';
import { OAuthCallbackModule } from './shared/login-callback/oauth-callback.module';
import { AuthenticationGuard } from './shared/azure-authentication/authentication.guard';
import { AdalService } from './shared/azure-authentication/adal.service';
import { ConfigService } from './shared/azure-authentication/config.service';
import { LoanAssignmentService } from './loan-assignment/loanassignment.service';
import { LoanOfficerRegionReferenceService } from './loan-officer-region-reference/loanofficerregionreference.service';
import { AppRoutingModule } from './app-route';
import { HomeComponent } from './home/home.component';
import { PersonaService } from './personas/persona.service';
import { RoleService } from './roles/role.service';
import { ConfigurationService } from './configuration/configuration.service';
import { TeamService } from './teams/team.service';
import { UserService } from './users/user.service';
import { CalendarService } from './calendar/calendar.service';
import { UserProfileService } from './userprofile/userprofile.service';
import { AuditService } from './audits/audit.service';
import { LoanProgramService } from './loanprograms/loanprogram.service';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { TeamEditComponent } from './teams/team-edit/team-edit.component';
import { TeamAddComponent } from './teams/team-add/team-add.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { FilterPersonaPipe } from './users/filter-persona.pipe';
import { UserAddComponent } from './users/user-add/user-add.component';
import { SearchService } from './shared/search.service';
import { OrderByField } from './users/user-details/orderByField.pipe';
import { SearchFilter } from './shared/searchFilter.pipe';
import { CalendarComponent } from './calendar/calendar.component';
import { CalendarEditComponent } from './calendar/calendar-edit/calendar-edit.component';
import { CalendarAddComponent } from './calendar/calendar-add/calendar-add.component';
import { CalendarEventTypeService } from './calendar/calendar-event-type.service';
import { LoanProgramsComponent } from './loanprograms/loanprograms.component';
import { ProgramsComponent } from './loanprograms/programs/programs.component';
import { ProgramListComponent } from './loanprograms/program-list/program-list.component';
import { ProgramsEditComponent } from './loanprograms/programs-edit/programs-edit.component';
import { ProgramAddComponent } from './loanprograms/program-add/program-add.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { UwAssignmentReshuffleComponent } from './uw-assignment-reshuffle/uw-assignment-reshuffle.component';
import { UwAssignmentReshuffleService } from './uw-assignment-reshuffle/uw-assignment-reshuffle.service';
import { CollateralskillsetsComponent } from './collateralskillsets/collateralskillsets.component';
import { SkillsetsComponent } from './collateralskillsets/skillsets/skillsets.component';
import { SkillsetListComponent } from './collateralskillsets/skillset-list/skillset-list.component';
import { CollateralskillsetEditComponent } from './collateralskillsets/collateralskillset-edit/collateralskillset-edit.component';
import { CollateralskillsetAddComponent } from './collateralskillsets/collateralskillset-add/collateralskillset-add.component';
import { CollateralskillsetsService } from './collateralskillsets/collateralskillsets.service';
import { PropertyTypesComponent } from './collateralskillsets/property-types/property-types.component';
import { PropertyTypeAddComponent } from './collateralskillsets/property-type-add/property-type-add.component';
import { PropertyTypeEditComponent } from './collateralskillsets/property-type-edit/property-type-edit.component';
import { PropertyTypeListComponent } from './collateralskillsets/property-type-list/property-type-list.component';
import { PropertyTypeService } from './collateralskillsets/property-type.service';
import { UwReshuffleDialogComponent } from './uw-reshuffle-dialog/uw-reshuffle-dialog.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerOverlayComponent } from './spinner-overlay/spinner-overlay.component';
import { SpinnerOverlayService } from './spinner-overlay/spinner-overlay.service';
import { ProcessorCloserPipelineReassignmentComponent } from './processor-closer-pipeline-reassignment/processor-closer-pipeline-reassignment.component';
import { ProcessorCloserReassignmentService } from './processor-closer-pipeline-reassignment/processor-closer-reassignment.service';
import { PendingProcessorPipelineReassignmentComponent } from './processor-closer-pipeline-reassignment/pending-processor-pipeline-reassignment/pending-processor-pipeline-reassignment.component';
import { PendingCloserPipelineReassignmentComponent } from './processor-closer-pipeline-reassignment/pending-closer-pipeline-reassignment/pending-closer-pipeline-reassignment.component';
import { ConfirmDialogComponent } from './processor-closer-pipeline-reassignment/confirm-dialog/confirm-dialog.component';
import { CloserReassignmentComponent } from './processor-closer-pipeline-reassignment/closer-reassignment/closer-reassignment.component';
import { ProcessorReassignmentComponent } from './processor-closer-pipeline-reassignment/processor-reassignment/processor-reassignment.component';
import { LoanAssignmentComponent } from './loan-assignment/loanassignment.component';
import { LoanOfficerRegionReferenceComponent } from './loan-officer-region-reference/loanofficerregionreference.component';
import { SubregionAssignment } from './loan-officer-region-reference/loanofficerregionreference.model';
import { SubregionListComponent } from './loan-officer-region-reference/subregion-list/subregion-list.component';
import { SubregionService } from './loan-officer-region-reference/subregions/subregions.service';
import { SubregionsComponent } from './loan-officer-region-reference/subregions/subregions.component';
import { SubregionEditComponent } from './loan-officer-region-reference/subregion-edit/subregion-edit.component';
import { SubregionAddComponent } from './loan-officer-region-reference/subregion-add/subregion-add.component';
import { CondoSkillsetsService } from './condoskillsets/condoskillsets.service';
import { UnderwriterTeamBalancerComponent } from './uw-team-balancer/uwteambalancer.component';
import { UnderwriterTeamBalancerService } from './uw-team-balancer/uwteambalancer.service';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        HeaderComponent,
        FooterComponent,
        TeamsComponent,
        LoanAssignmentComponent,
        LoanOfficerRegionReferenceComponent,
        TeamListComponent,
        TeamComponent,
        UserDetailsComponent,
        SidebarComponent,
        TeamEditComponent,
        TeamAddComponent,
        UserAddComponent,
        UserEditComponent,
        FilterPersonaPipe,
        SearchFilter,
        CalendarComponent,
        CalendarEditComponent,
        CalendarAddComponent,
        OrderByField,
        LoanProgramsComponent,
        ProgramsComponent,
        ProgramListComponent,
        ProgramsEditComponent,
        ProgramAddComponent,
        ConfigurationComponent,
        CollateralskillsetsComponent,
        SkillsetsComponent,
        SkillsetListComponent,
        CollateralskillsetEditComponent,
        CollateralskillsetAddComponent,
        ConfigurationComponent,
        UwAssignmentReshuffleComponent,
        PropertyTypesComponent,
        PropertyTypeAddComponent,
        PropertyTypeEditComponent,
        PropertyTypeListComponent,
        UwAssignmentReshuffleComponent,
        UwReshuffleDialogComponent,
        SpinnerComponent,
        SpinnerOverlayComponent,
        ProcessorCloserPipelineReassignmentComponent,              
        CloserReassignmentComponent,
        PendingProcessorPipelineReassignmentComponent,
        PendingCloserPipelineReassignmentComponent,
        ProcessorReassignmentComponent,
        ConfirmDialogComponent,
        SubregionListComponent,
        SubregionsComponent,
        SubregionEditComponent,
        SubregionAddComponent,
        UnderwriterTeamBalancerComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        MatSidenavModule,
        MatDialogModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatCardModule,
        MatChipsModule,
        MatButtonModule,
        MatInputModule,
        MatTooltipModule,
        MatRadioModule,
        MatTableModule,
        MatPaginatorModule,
        TreeModule,
        DataTableModule,
        SharedModule,
        BrowserModule,
        OAuthCallbackModule,
        AppRoutingModule,
        ReactiveFormsModule
    ],
    entryComponents: [
        UserDetailsComponent,
        UserEditComponent,
        TeamEditComponent,
        TeamAddComponent,
        UserAddComponent,
        CalendarEditComponent,
        CalendarAddComponent,
        ProgramsEditComponent,
        ProgramAddComponent,
        ConfigurationComponent,
        CollateralskillsetAddComponent,
        CollateralskillsetEditComponent,
        ConfigurationComponent,
        UwAssignmentReshuffleComponent,
        PropertyTypeAddComponent,
        PropertyTypeEditComponent,
        ConfigurationComponent,
        UwReshuffleDialogComponent,
        SpinnerOverlayComponent,
        SpinnerComponent,
        ConfirmDialogComponent,
        SubregionEditComponent,
        SubregionAddComponent
    ],
    providers: [
        AuthenticationGuard,
        AdalService,
        ConfigService,
        { provide: BaseEndpoint, useValue: environment.baseApiUrl },
        TeamService,
        PersonaService,
        UserService,
        UserProfileService,
        LoanProgramService,
        AuditService,
        SearchService,
        RoleService,
        ConfigurationService,
        CalendarService,
        CalendarEventTypeService,
        UwAssignmentReshuffleService,
        CollateralskillsetsService,
        PropertyTypeService, SpinnerOverlayService,
        ProcessorCloserReassignmentService,
        LoanAssignmentService,
        LoanOfficerRegionReferenceService,
        SubregionService,
        CondoSkillsetsService,
        UnderwriterTeamBalancerService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/app.module.ts